import type { LocalDate } from '../../store';

export interface PlannedDates {
  plannedArrivalEnd: LocalDate;
  plannedArrivalStart: LocalDate;
  plannedDepartureEnd: LocalDate;
  plannedDepartureStart: LocalDate;
}
